import { Link, NavLink, Outlet } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import BBrand from "../components/b/BBrand";

const NAV_ITEMS: { label: string; to: string }[] = [
  { label: "Product", to: "/" },
  { label: "How it works", to: "/how-it-works" },
  { label: "FAQ", to: "/faq" },
];

export default function PublicLayout() {
  const { user } = useAuth();

  return (
    <div className="public-shell">
      <header className="public-header">
        <div className="public-header-inner">
          <BBrand to="/" />
          <nav className="public-nav">
            {NAV_ITEMS.map((it) => (
              <NavLink key={it.label} to={it.to} end className={({ isActive }) => (isActive ? "active" : "")}>
                {it.label}
              </NavLink>
            ))}
          </nav>
          <div className="public-cta">
            {user ? (
              <Link to="/app/dashboard" className="btn btn-primary">
                Open dashboard <ArrowRight size={15} />
              </Link>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost" style={{ border: 0, boxShadow: "none" }}>
                  Sign in
                </Link>
                <Link to="/register" className="btn btn-primary">
                  Get started
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="public-main">
        <Outlet />
      </main>

      <footer className="public-footer">
        <div className="public-footer-inner">
          <BBrand to="/" size="sm" />
          <span className="footer-spacer" />
          <Link to="/how-it-works">How it works</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <span>© {new Date().getFullYear()} Set &amp; Ledger</span>
        </div>
      </footer>
    </div>
  );
}
